// extracted by mini-css-extract-plugin
export default {"autoRechargeForm":"AutoRechargeModal_autoRechargeForm__6y4Uf"};